export const listString = (items: string[]) =>
  items?.length > 1 ? items.slice(0, -1).join(', ') + ' & ' + items.slice(-1)[0] : items[0]
